import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";
import {BotonLetras, BotonUp, BotonCancelar} from "../Plantillas/Botones.js";
import {notificationStockInicial} from "./KardexNotify.js";
import "react-moment";
import moment from "moment";
import { formatSoles } from "../../Global";

class TablaStockInicial extends React.Component {

    render() {
        const {data, table, onFetchData} = this.props

        return (
            <ReactTable
                data={data}
                pages={table.pages}
                loading={table.isLoading}
                manual={true}
                filterable={true}
                sortable={true}
                onFetchData={(state, instance) => onFetchData(state, instance)}
                columns={[
                    {
                        Header: "Código",
                        id: "Codigo",
                        headerClassName: "",
                        width: 100,
                        accessor: d => d.Codigo,
                    },
                    {
                        Header: "Nombre",
                        id: "Nombre",
                        headerClassName: "",
                        width: 300,
                        accessor: d => d.Nombre,
                    },
                    {
                        Header: "Precio Costo con IGV",
                        id: "Precio",
                        headerClassName: "",
                        width: 200,
                        accessor: d => d.Precio,
                        Cell: this.props.renderEditable,
                        filterable: false,
                    },
                    {
                        filterable: false,
                        Header: "Cantidad",
                        id: "Stock",
                        headerClassName: "",
                        width: 100,
                        accessor: d => d.Stock,
                        Cell: this.props.renderEditable
                    },
                    {
                        Header: "",
                        filterable: false,
                        headerClassName: "",
                        width: 80,
                        Cell: original => {
                            return (
                                this.props.disableButton ? (
                                        <button className="btn btn-primary" type="button" disabled>
                                            <span className="spinner-border spinner-border-sm" role="status"
                                                  aria-hidden="true"/>
                                            <span className="sr-only">Cargando...</span>
                                        </button>
                                    ) :
                                    (<BotonUp
                                        title="Agregar Stock Inicial"
                                        onClick={() => this.props.AddMA(original.original)
                                            .then(() => notificationStockInicial())}
                                    />)

                            );
                        }
                    }
                ]}
                defaultPageSize={10}
                previousText="Anterior"
                nextText="Siguiente"
                noDataText="No se encontraron registros"
                loadingText="Cargando..."
                ofText="de"
                rowsText="filas"
                pageText="Página"
                pageSizeOptions={[10, 20, 25, 50, 100]}
            />
        )
    }
}

export default TablaStockInicial
